import { Navigate } from 'react-router-dom'
import useCustomer from '@/containers/SubscriptionFormPageNew/Components/Customer/useCustomer'
import FormStatusError from './FormStatusError'

const CreateForm = () => {
  const { zohoId, errors } = useCustomer()

  if (errors?.error) {
    return (
      <FormStatusError
        statusCode={errors.error.statusCode || 500}
        customMessage={errors.error.responseData?.error || 'An error occurred'}
      />
    )
  }

  if (zohoId === '' || zohoId === null) {
    return <p>Creation du contrat en cours v2....</p>
  }

  return <Navigate to={'/contact/' + zohoId} />
}

export default CreateForm
